"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_options_core_2 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(legacy_1.action('saveAttachmentPreferencesOption')(function saveAttachmentPreferencesOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.AttachOrShareLocalFiles = owa_options_core_1.getFallbackValueIfNull(optionState.fromComputer, userOptions.AttachOrShareLocalFiles);
                    userOptions.AttachOrShareCloudFiles = owa_options_core_1.getFallbackValueIfNull(optionState.fromOneDrive, userOptions.AttachOrShareCloudFiles);
                    return [4 /*yield*/, owa_options_core_2.updateUserConfiguration([
                            {
                                propertyName: 'AttachOrShareLocalFiles',
                                propertyType: 'Integer32',
                                propertyValue: "" + userOptions.AttachOrShareLocalFiles,
                            },
                            {
                                propertyName: 'AttachOrShareCloudFiles',
                                propertyType: 'Integer32',
                                propertyValue: "" + userOptions.AttachOrShareCloudFiles,
                            },
                        ], 'OWA.ViewStateConfiguration')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveAttachmentPreferencesOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-attachment-preferences-option/lib/actions/saveAttachmentPreferencesOption.js
// module id = 4985
// module chunks = 2